// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!@css/utils");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, "._7mSUotWnx{margin-bottom:20px}._6sva0Ydxx{margin-bottom:20px;background-color:var(--banner-blue)}._7mnKHICjx{flex:1}._7mnKHICjx ._2ox4D90ex{flex:0 0 auto;align-self:flex-start}._7mnKHICjx ._1YhAPyiQx{flex:1 0 60%;margin:0 8px 0 20px}._7mnKHICjx ._1YhAPyiQx ._2IlSEwdYx{font-size:20px;margin-bottom:7px}._7mnKHICjx ._1YhAPyiQx .lu19a2WCx{max-width:620px;font-size:14px}._7mnKHICjx ._66Lk6wsCx{flex:0 0 auto;cursor:pointer;align-self:flex-end;margin-left:8px}._7mnKHICjx .STqgeyxix{color:var(--link-text);margin-left:4px;text-decoration:none}._2ToxEYRkx,._2OoslptXx{opacity:0.01;max-height:0}._2ToxEYRkx._1VysMvFPx,._2OoslptXx._2dfw5IsSx{opacity:1;max-height:500px;transition:max-height .7s,opacity .7s}._2EssM21qx{opacity:1;max-height:500px}._2EssM21qx._7bEaQ5eIx{opacity:0;max-height:0;transition:max-height .7s,opacity .7s}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"info-banner": "_7mSUotWnx",
	"infoBanner": "_7mSUotWnx",
	"blue-banner": "_6sva0Ydxx",
	"blueBanner": "_6sva0Ydxx",
	"container": "_7mnKHICjx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["vertically-center"] + "",
	"image": "_2ox4D90ex",
	"content": "_1YhAPyiQx",
	"title": "_2IlSEwdYx",
	"description": "lu19a2WCx",
	"link": "_66Lk6wsCx",
	"hyperlink": "STqgeyxix",
	"enter": "_2ToxEYRkx",
	"appear": "_2OoslptXx",
	"enter-active": "_1VysMvFPx",
	"enterActive": "_1VysMvFPx",
	"appear-active": "_2dfw5IsSx",
	"appearActive": "_2dfw5IsSx",
	"leave": "_2EssM21qx",
	"leave-active": "_7bEaQ5eIx",
	"leaveActive": "_7bEaQ5eIx"
};
module.exports = exports;
